<section>
    <section class="team-page-section">
        <div class="container">
            <!-- Sec Title -->
            <div class="sec-title centered">
                <div class="title">Nuestro equipo</div>
                <h3>Trabajamos para brindarte soluciones en esta nueva etapa de tu vida.</h3>
            </div>

            <div class="row clearfix center">

                <!-- Team Block -->
                <div class="team-block col-lg-4 col-md-6 col-sm-12">
                    <div class="inner-box wow fadeInLeft" data-wow-delay="0ms" data-wow-duration="1500ms">
                        <ul class="social-icons">
                            <li><a href="https://www.facebook.com/sebastian.jimenezbenavides?mibextid=uzlsIk" target="_blank"><i class="fab fa-facebook-f"></i></a></li>
                            <li><a href="https://www.instagram.com/sebasjimenez_cr/" target="_blank"><i class="fab fa-instagram"></i></a></li>
                            <li><a href="https://www.linkedin.com/in/sebasjimenezb/" target="_blank"><i class="fab fa-linkedin-in"></i></a></li>
                        </ul>
                        <div class="image">
                            <a href="javascript: void(0)"><img src="https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/2d1e9661-7824-411a-a37b-b26ef27d1600/public" alt="" /></a>
                        </div>
                        <div class="lower-content">
                            <h3><a href="javascript: void(0)">Sebastián Jiménez B.</a></h3>
                            <div class="designation">C.E.O</div>
                            <p>Ingeniero en Sistemas</p>
                            <h5><i class="fas fa-map-marker-alt"></i> Madrid</h5>
                            <p>11 años viviendo en Europa</p>
                        </div>
                    </div>
                </div>
                <!-- Team Block -->
                <div class="team-block col-lg-4 col-md-6 col-sm-12">
                    <div class="inner-box wow fadeInLeft" data-wow-delay="0ms" data-wow-duration="1500ms">
                        <ul class="social-icons">
                            <li><a href="https://www.facebook.com/felipe.hidalgo.167?mibextid=uzlsIk" target="_blank"><i class="fab fa-facebook-f"></i></a></li>
                            <li><a href="https://www.instagram.com/11hidalgofelipe13/"  target="_blank"><i class="fab fa-instagram"></i></a></li>
                            <li><a href="https://www.linkedin.com/in/felipehidalgogonzalez/" target="_blank"><i class="fab fa-linkedin-in"></i></a></li>
                        </ul>
                        <div class="image">
                            <a href="javascript: void(0)"><img src="https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/831ebee7-dc69-43ad-5556-199c38739600/public" alt="" /></a>
                        </div>
                        <div class="lower-content">
                            <h3><a href="javascript: void(0)">Felipe Hidalgo G.</a></h3>
                            <div class="designation">C.O.O</div>
                            <p>MsC Logistics and Supply Management</p>
                            <h5><i class="fas fa-map-marker-alt"></i> Barcelona</h5>
                            <p>9 años viviendo en Europa</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</section>